import * as GLOBAL_LABELS from "../labels/global";

export const LABELS = {
    [GLOBAL_LABELS.GLOBAL_DELETE]: "削除",
    [GLOBAL_LABELS.GLOBAL_CANCEL]: "キャンセル",
    [GLOBAL_LABELS.GLOBAL_UNKNOWN]: "不明",

    [GLOBAL_LABELS.GLOBAL_TEST_ENVIRONMENT_BANNER_TEST_MODE]: "테스트 모드",
    [GLOBAL_LABELS.GLOBAL_TEST_ENVIRONMENT_BANNER_LIVE_TEST_MODE]: "실전 테스트 모드",
    [GLOBAL_LABELS.GLOBAL_ENVIRONMENT_MODE_CONFIRMATION_MODAL_MESSAGE]: "이 결제는 {mode} 상태입니다. 실제 결제는 이루어지지 않습니다.",
    [GLOBAL_LABELS.GLOBAL_ENVIRONMENT_MODE_CONFIRMATION_MODAL_BUTTON]: "알겠습니다",
};

export default LABELS;
